<template>
  <div
    class="bg-content-section flex flex-col items-center justify-center pt-10 pb-6 overflow-hidden px-4"
  >
    <section-title title-path="title-1.png" />
    <div class="row w-full max-w-1280 flex flex-wrap justify-center mt-14 z-10">
      <a
        v-for="(content, index) in contents"
        :key="content.image"
        :style="{
          'background-image':
            'url(' +
            imgPath +
            '/slide2/content' +
            (index + 1) +
            '_sprites.png)',
        }"
        class="menu-btn relative inline-block w-123 h-119 m-1 bg-cover bg-no-repeat cursor-pointer"
        :href="content.link"
      ></a>
    </div>
    <img
      class="absolute bottom-1/10 right-0.3/10 h-auto m-auto"
      :src="imgPath + '/slide2/bird.png'"
    />
  </div>
</template>

<script>
import breakpoints from '@/plugins/breakpoints';
import SectionTitle from '../components/SectionTitle/SectionTitle';
export default {
  name: 'content-section',
  components: {
    SectionTitle,
  },
  props: {
    moveTo: Function,
  },
  data: function() {
    return {
      breakpoints,
      imgPath: process.env.VUE_APP_IMG_URL,
      contents: [
        { image: '/content1.png', link: '#story' },
        { image: '/content2.png', link: '#class' },
        { image: '/content3.png', link: '#dungeons' },
        { image: '/content4.png', link: '#skills' },
        { image: '/content5.png', link: '#champions' },
        { image: '/content6.png', link: '#summonables' },
        { image: '/content7.png', link: '#stats' },
        { image: '/content8.png', link: '#companions' },
        { image: '/content9.png', link: '#combat' },
      ],
    };
  },
};
</script>

<style lang="postcss" scoped>
.menu-btn {
  text-indent: -9999px;
}
.menu-btn span {
  @apply absolute inset-0 bg-274-10 xl:invisible;
  content: '';
  opacity: 0;
  -webkit-transition: opacity 0.5s;
  -moz-transition: opacity 0.5s;
  -o-transition: opacity 0.5s;
}
.menu-btn:hover span {
  opacity: 1;
}
</style>
